import axios from "axios";
import BaseService from "./baseService";

class ServiceNoReplyEmailController extends BaseService {
  async processUnreadEmails() {
    const response = await axios.post("/api/noReplyEmail/processUnreadEmails");
    return response.data;
  }
  async getStatus() {
    const response = await axios.get("/api/noReplyEmail/status");
    return response.data;
  }
}

export const ServiceNoReplyEmail = new ServiceNoReplyEmailController();